<div class="w-full grid align-content-center py-6">
  <div class="col-12 md:col-8 md:col-offset-2">
    <h1 i18n>Cookie Policy</h1>
    <p i18n>This policy details how Suzuki GB Plc (referred to as “we”, “us” or “our”) uses cookies when you visit our websites (sites).</p>
    <p-divider />
    <h2 i18n>What is a cookie?</h2>
    <p i18n>A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree.  Cookies contain information that is transferred to your computer's hard drive.</p>

    <p-divider />
    <h2 i18n>Consent to receive cookies</h2>
    <p i18n>By accessing, browsing and using our Site, you are agreeing to our use of strictly necessary cookies.</p>
    <p i18n>You can disable cookies from your browser and delete all cookies currently stored on your computer or smart device. At anytime you can manage the use of these types of cookies by visiting:</p>
    <div class="align-content-center">
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">Manage Cookies</button>
    </div>

    <p i18n>Please be aware that if you disable cookies from your browser you may be unable to access or use certain parts of this site.</p>
    <p i18n>Unless you have adjusted your browser setting so that it disables cookies, our system will issue cookies when you access this site.</p>

    <p-divider />
    <h2 i18n>What are the cookies doing and why?</h2>
    <p i18n>We may collect standard internet log information, including where available your IP address, operating system and browser type, for system administration and usage reporting. We collect these details in a way that does not identify you.</p>

    <p i18n>Cookies enable us to:</p>
    <ul>
      <li i18n>Customise our Site according to your individual preferences.</li>
      <li i18n>Carry out research and development, including improvement on this site.</li>
      <li i18n>Recognise you when you return to this site.</li>
    </ul>
    <p-divider />
    <h2 i18n>Cookies used on this site</h2>

    <p i18n>We may use the following cookies on this site:</p>
    <ul>
      <li i18n><span class="font-bold">Strictly necessary cookies.</span> These are cookies that are required for the operation of our Site. They include, for example, cookies that enable you to log into secure areas of our Site, use a shopping cart or make use of e-billing services.</li>
      <li i18n>You can find more information about the individual cookies we use by visiting: <button id="ot-sdk-btn" class="ot-sdk-show-settings">Manage Cookies</button></li>
    </ul>
    <p-divider/>

  </div>
</div>
